import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import chLogo from '~/assets/ch_logo.png';

import sx from './sx';

export const AuthLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const theme = useTheme();
  const style = sx(theme);

  return (
    <Box sx={style.container}>
      <Box sx={style.poster} />
      <Box sx={style.sidebar}>
        <Box sx={style.logoWrap}>
          <img src={chLogo} />
        </Box>
        {children}
      </Box>
    </Box>
  );
};
